// skipcq: JS-W1028
import { useMemo } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import { getBeerTagLabelsForCategory } from '../../utils/brewhouseBeerStats';
import BeerProfileRatingPanel from './BeerProfileRatingPanel';

const RATING_PANELS = [
  { key: 'overall', label: 'Overall' },
  { key: 'appearance', label: 'Appearance' },
  { key: 'aroma', label: 'Aroma' },
  { key: 'flavor', label: 'Flavor' },
  { key: 'mouthfeel', label: 'Mouthfeel' },
];

function BeerProfileAggregatedRatingsCard({ ratings, tags, tagLabelMap }) {
  const tagEntriesByKey = useMemo(() => {
    const entries = {};
    RATING_PANELS.forEach((panel) => {
      if (panel.key === 'overall') {
        entries[panel.key] = [];
        return;
      }
      entries[panel.key] = getBeerTagLabelsForCategory(tags, tagLabelMap, panel.key);
    });
    return entries;
  }, [tags, tagLabelMap]);

  return (
    <Card variant="outlined" sx={{ bgcolor: 'background.paper', height: '100%' }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 }, '&:last-child': { pb: { xs: 2, sm: 3 } } }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          Ratings
        </Typography>
        {RATING_PANELS.map((panel) => (
          <BeerProfileRatingPanel
            key={panel.key}
            label={panel.label}
            rating={ratings?.[panel.key]}
            tags={tagEntriesByKey[panel.key]}
          />
        ))}
      </CardContent>
    </Card>
  );
}

BeerProfileAggregatedRatingsCard.propTypes = {
  ratings: PropTypes.shape({
    overall: PropTypes.number,
    appearance: PropTypes.number,
    aroma: PropTypes.number,
    flavor: PropTypes.number,
    mouthfeel: PropTypes.number,
  }),
  tags: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        tag: PropTypes.string,
        count: PropTypes.number,
      }),
    ),
  ),
  tagLabelMap: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default BeerProfileAggregatedRatingsCard;
